import React, { useState, useEffect, useContext, useCallback } from "react";
import { useLocation, useHistory, useParams } from "react-router-dom";

import JobDetailsEditor from "../../screens/jobDetailsTabs/jobDetailsEditor";
import EscalationEditor from "../../screens/jobDetailsTabs/escalationsEditor";
import JobPurchaseTab from "./jobPurchaseTab";
import DistributionEditor from "../../screens/jobDetailsTabs/distributionEditor"
import { parseJobApiResponse } from "../../utils";
import {useLazyGetEscalationsQuery} from "../../services/jobsApi";

import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";

import JobEditTabsHeader from "../jobDetailsTabs/jobEditTabsHeader";

import { Grid } from "@mui/material";
import { useLazyJobQuery } from "../../services/jobsApi";
import { useSelector } from "react-redux";
import { selectCurrentUser } from "../../features/auth/authSlice";
import SignalREncorehiveContext from "@/context/signalREncorehive";
import Notification from "@/components/Notification";
import BasicModalInformation from "@/components/basicModalInformation";

async function useEscalationsGetById(jobId) {
  const [initGetEscalations, {isLoading: getEscalationsIsLoading}] = useLazyGetEscalationsQuery();

  let escalationsFullInfo = await initGetEscalations(jobId).unwrap();

  let escalationForThisJob = escalationsFullInfo.res.jobEscalations;

  let activeEscalations = escalationForThisJob.filter(escalation => escalation.issueResolved == null)[0] || {};
  let escalationHistory = escalationForThisJob.filter(escalation => escalation.issueResolved != null);

  return { activeEscalations, escalationHistory };
}

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

export default function JobEditTabs() {
  const { signalREncorehive  } = useContext(SignalREncorehiveContext);
  const user= useSelector(selectCurrentUser);
  const location = useLocation();
  const query = new URLSearchParams(location.search);
  const history = useHistory();
  let { jobId } = useParams();
  const [getJob] = useLazyJobQuery();

  const [jobInfo, setJobInfo] = useState();
  const [escalation, setEscalation] = useState({});

  const [notification, setNotification] = useState({
    snackBarOpenProp: false,
    status: null,
    text: null,
  });

  useEffect(() => {
    if(jobInfo?.escalationActive){
      setEscalation(jobInfo.escalationActive);
    }
  }, [jobInfo]);

  async function getJobInfo() {
    try {
      let res = await getJob(jobId).unwrap();
      console.log("JOB INFO before parse", res)
      let jobInfo = parseJobApiResponse(res.res)[0];
      console.log("jobInfo ", jobInfo);
      setJobInfo(jobInfo);
    } catch (error) {
      if (error.status == 401) return; //error managed on baseQueryWithReauth 
    }
  }

  // Handler for the HardEscalate event from SignalR
  const handleHardEscalate = useCallback((jobHardEscalatedId) => {
    console.log('[handleHardEscalate] HardEscalate jobId received:', jobHardEscalatedId);
    console.log('[handleHardEscalate] escalation: ', escalation);
    let adminIsOwnerOfActiveEscalation=false;
    if(escalation && escalation.issueResolvedSTNUserID == user.id){
      console.log('[handleHardEscalate] Admin is owner of active escalation');
      adminIsOwnerOfActiveEscalation=true;
    } else {
      console.log('[handleHardEscalate] Admin is not owner of active escalation');
    }
    if(jobId == jobHardEscalatedId 
      && adminIsOwnerOfActiveEscalation){
      console.log("[handleHardEscalate] Current admin lost ownership of active escalation");
      setNotification({
        snackBarOpenProp: true,
        status: "OK",
        title: "This Escalation has been taken by another admin",
        handleClose: ()=> history.push("/dashboard/admintools")
      });
    } else {
      console.log("[handleHardEscalate] Current admin is still owner of active escalation");
    }
  }, [escalation, user, jobId]);  // Dependencias para que se actualice cuando cambien estos valores

  useEffect(() => {
    getJobInfo();
    
    // Register the handler for the HardEscalate event
    if (signalREncorehive) {
      signalREncorehive.on('HardEscalate', handleHardEscalate);
    }
    
    // Cleanup function when the component is unmounted
    return () => {
      if (signalREncorehive) {
        signalREncorehive.off('HardEscalate', handleHardEscalate);
      }
    };
  }, [signalREncorehive, handleHardEscalate]);  // Añadimos handleHardEscalate como dependencia


  function getUserCanEdit(){
    if(!jobInfo) return false;
    let {escalationActive}= jobInfo;
    if (escalationActive?.issueResolvedSTNUserID && user?.id && escalationActive?.issueResolvedSTNUserID == user?.id) {
      return true;
    }
    return false;
  }


  let tabIndexFromQuery = Number(query.get("tab_index") || 0);
  const [tabIndex, setTabIndex] = React.useState(tabIndexFromQuery);

  const handleChange = (event, newValue) => {
    setTabIndex(newValue);
    query.set("tab_index", newValue);
    history.push({ search: query.toString() });
  };
  // --------------------------------------------------------------------------------------
  console.log("jobInfo: " , jobInfo)
  // ------------------------------------------------------------------------------------------
  return (
    // <div className="admin-jobs-details">

    <Box
      sx={{
        margin: "auto",
        padding: "8em 2em 0 2em",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "flex-start",
        width: { xs: "100%", sm: "90%", md: "80%", lg: "70%", xl: "60%" },
      }}
    >
      <BasicModalInformation
        open={notification.snackBarOpenProp}
        handleClose={notification.handleClose}
        title={notification.title}
        description={notification.description}
        status={notification.status}
        text={notification.text}
      />
      {/* ------------------------------------------------------------------------------------------ */}
      <JobEditTabsHeader jobInfo={jobInfo} setJobInfo={setJobInfo} getJobInfo={getJobInfo}/>
      {/* ------------------------------------------------------------------------------------------ */}
      <Grid sx={{ width: "100%" }}>
        <Box
          sx={{
            borderBottom: 1,
            borderColor: "var(--light-yellow)",
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <Tabs
            value={tabIndex}
            onChange={handleChange}
            aria-label="basic tabs example"
            textColor="primary"
            indicatorColor="primary"
          >
            <Tab label="Jobs Details Editor" {...a11yProps(0)} />
            <Tab label="distribution" {...a11yProps(1)} />
            <Tab label="Escalations" {...a11yProps(2)} />
            <Tab label="Purchase" {...a11yProps(3)} />
          </Tabs>
        </Box>

        {/* tabs for edit Jobs on Admin tools */}

        <TabPanel value={tabIndex} index={0}>
          <JobDetailsEditor
            userCanEditJob={getUserCanEdit()}
            jobCompleteInfo={jobInfo}
            setJobInfo={setJobInfo}
            escalation={escalation}
            setEscalation={setEscalation}
            getJobInfo={getJobInfo}
          />
        </TabPanel>

        <TabPanel value={tabIndex} index={1}>
          <DistributionEditor
            jobInfo={jobInfo?.job}
            setJobInfo={setJobInfo}
            eventInfo={jobInfo?.event}
            userCanEditJob={getUserCanEdit()}
            escalation={escalation}
            setEscalation={setEscalation}
            getJobInfo={getJobInfo}
          />
        </TabPanel>

        <TabPanel value={tabIndex} index={2}>
          <EscalationEditor
            userCanEditJob={getUserCanEdit()}
            jobId={jobId}
            jobInfo={jobInfo?.job}
            activeEscalation={jobInfo?.escalationActive}
            escalationHistory={jobInfo?.escalationHistory}
            escalation={escalation}
            setEscalation={setEscalation}
          />
        </TabPanel>

        <TabPanel value={tabIndex} index={3}>
          <JobPurchaseTab userCanEditJob={getUserCanEdit()} jobId={jobId} jobInfo={jobInfo}/>
        </TabPanel>

      </Grid>
    </Box>

    //{/* <JobHistoryDrawer/> */}

    // </div>
  );
}
